import angular from 'angular';
import uiRouter from 'angular-ui-router';
import userCardListComponent from './userCardList.component';

let userCardListModule = angular.module('userCardList', [
  uiRouter,
])

  .component('userCardList', userCardListComponent)

  .name;

export default userCardListModule;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/userCardList/userCardList.js